import {
  type IAdditionalService,
  type IDetailedAdditionalService,
  type IOrderedAdditionalServiceData,
} from "@services/additional-services/types";
import type { IFile } from "@services/jointBillServices/types";
import type { IOverviewJointBillService } from "@services/overview/types";
import { api } from "@/api";

export const getAdditionalServices = (): Promise<IAdditionalService[]> =>
  api
    .get<{ additionalServices: IAdditionalService[] }>("/additional-services")
    .then((r) => r.data?.additionalServices);

export const getAdditionalService = (
  serviceId: IAdditionalService["additionalServiceId"],
): Promise<IDetailedAdditionalService> =>
  api
    .get<IDetailedAdditionalService>(`/additional-services/${serviceId}`)
    .then((r) => r.data);

export const subscribeAdditionalService = (
  serviceId: IAdditionalService["additionalServiceId"],
  jointBillServiceId: number,
): Promise<void> =>
  api.post(`/additional-services/${serviceId}/subscriptions`, "", {
    headers: {
      jointBillServiceId,
    },
  });

export const getPromotedAdditionalServices = (): Promise<
  IAdditionalService[]
> =>
  api
    .get<{
      additionalServices: IAdditionalService[];
    }>("/additional-services/advertisements")
    .then((r) => r.data?.additionalServices);

export const unsubscribeAdditionalService = (
  serviceId: IAdditionalService["additionalServiceId"],
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
  jointBillServiceAgreementId?: IOrderedAdditionalServiceData["jointBillServiceAgreementId"],
): Promise<void> =>
  api.delete(`/additional-services/${serviceId}/subscriptions`, {
    headers: {
      jointBillServiceId,
    },
    params: {
      jointBillServiceAgreementId,
    },
  });

export const downloadAdditionalServiceFiles = async (
  serviceProviderId: number,
  jointBillServiceId: number,
) =>
  (
    await api.get<IFile>(`/additional-services/${serviceProviderId}/files`, {
      headers: { jointBillServiceId },
    })
  ).data;
